import { FeatureData } from '../../components/ui/feature-section-with-hoover-effect';
import {
  IconBrandReact,
  IconDeviceMobile,
  IconSeo,
  IconSpeedboat,
} from '@tabler/icons-react';

const webDevelopmentFeatures: FeatureData[] = [
  {
    title: 'Sites Web Modernes',
    description:
      'Développement de sites web réactifs et modernes avec les dernières technologies front-end.',
    icon: <IconBrandReact size={24} />,
  },
  {
    title: 'Applications Mobiles',
    description:
      'Création d\'applications mobiles natives et cross-platform pour iOS et Android.',
    icon: <IconDeviceMobile size={24} />,
  },
  {
    title: 'Optimisation SEO',
    description:
      'Améliorez votre visibilité en ligne avec des stratégies d\'optimisation pour les moteurs de recherche.',
    icon: <IconSeo size={24} />,
  },
  {
    title: 'Performance Web',
    description:
      'Optimisation des temps de chargement et de la performance globale de vos applications web.',
    icon: <IconSpeedboat size={24} />,
  },
];

export default webDevelopmentFeatures; 